import { format, parseISO } from "date-fns";

const AUD = new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" });

export const money = (v) => AUD.format(Number(v) || 0);

export const fmtDate = (iso, pattern = "EEE d MMM yyyy") => (iso ? format(parseISO(iso), pattern) : "—");

export const fmtTime = (t) => {
  if (!t) return "—";
  const [h, m] = t.split(":").map(Number);
  const suffix = h >= 12 ? "pm" : "am";
  return `${h % 12 || 12}:${String(m).padStart(2, "0")}${suffix}`;
};

export const toISO = (d) => format(d, "yyyy-MM-dd");

export const todayISO = () => toISO(new Date());

export const fmtDateTime = (iso) => (iso ? format(new Date(iso), "d MMM yyyy, h:mma") : "");
